import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LANGUAGE } from "@/constants/languages";
import { detectLocaleFromUrl } from "@/utils/detectLocaleFromUrl";

const currentLanguage = detectLocaleFromUrl() || DEFAULT_LANGUAGE;

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: currentLanguage, // Set language based on URL
    fallbackLng: DEFAULT_LANGUAGE,
    // fallbackLng: false,
    ns: ["translation", "errors"],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json", // Translation file path
    },
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

i18n.on("failedLoading", (lng, ns, msg) => {
  console.error(
    `Failed to load language: ${lng}, namespace: ${ns}, error: ${msg}`
  );
  console.error(`Attempted to load: /locales/${lng}/translation.json`);
});

export default i18n;
